<template>
  <div class="auth_title_wrapper">
    <div class="img_wrapping">
      <img
        src="@/assets/images/authlogo.png"
        alt="authLogo"
        draggable="false"
      />
    </div>
    <div class="slots_text static_text">
      <slot name="title"></slot>
    </div>
    <div class="slots_text text-capitalize">
      <slot name="title_two"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "AuthTitle",
};
</script>
<style lang="scss" scoped>
.auth_title_wrapper {
  margin-bottom: 1.5rem;
  .img_wrapping {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      // max-height: 120px;
    }
  }
  .slots_text {
    display: flex;
    justify-content: center;
    align-items: center;
    color: $text_color;
    padding: 1rem 0;
    font-size: 18px;
    font-weight: 600;
    &.static_text {
      padding: 0.5rem 0 0;
      font-size: 26px;
      font-weight: 600;
    }
  }
}
</style>
